import { Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from 'components/dropdown/dropdown';
import { useAnalytics } from 'analytics';
import { ANALYTICS_EVENTS } from 'analytics/events';
import { TitleBarLeading } from './TitleBarLeading';
import { WorkstationMenuItems } from './WorkstationMenuItems';
import { ActionsArea, PreLoginMenuButton, TitleBarNav } from './TitleBar.styles';

export default function PreLoginTitleBar({
  title,
  hasBackButton,
}: {
  title?: string;
  hasBackButton: boolean;
}) {
  const { t } = useTranslation();
  const { trackEvent } = useAnalytics();

  return (
    <TitleBarNav $dark={false}>
      <TitleBarLeading
        title={title}
        hasBackButton={hasBackButton}
        logoSrc="/images/logo-topbar-classic.svg"
        wideLogo
      />
      <ActionsArea>
        <DropdownMenu
          onOpenChange={(open) => {
            if (open) {
              trackEvent(ANALYTICS_EVENTS.TITLEBAR_MENU_OPENED, {
                hasBackButton,
                hasTitle: Boolean(title),
                hasInteractionId: false,
              });
            }
          }}
        >
          <DropdownMenuTrigger asChild>
            <PreLoginMenuButton aria-label={t('settings')}>
              <Settings size={20} />
            </PreLoginMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-56" align="end">
            <WorkstationMenuItems />
          </DropdownMenuContent>
        </DropdownMenu>
      </ActionsArea>
    </TitleBarNav>
  );
}
